import React, { Component, ChangeEvent, KeyboardEvent, CSSProperties } from 'react';
import { InputGroup, Input, InputGroupAddon, InputGroupText } from 'reactstrap';
import { InputType } from 'reactstrap/lib/Input';

type InputWithLabelProps = {
    label: string;
    type?: InputType;
    name?: string;
    id?: string;
    value?: string | ReadonlyArray<string> | number;
    onChange(event: ChangeEvent<HTMLInputElement>): void;
    onBlur?(event: ChangeEvent<HTMLInputElement>): void;
    onKeyPress?(event: KeyboardEvent): void;
    inputClass?: string; 
    options?: SelectOption[];
    disabled?: boolean;
    fullWidth?: boolean;
};

export type SelectOption = {
    value: string | number;
    label: string;
    disabled?: boolean
}

export default class InputWithLabel extends Component<InputWithLabelProps> {
    static displayName = InputWithLabel.name;

    getOptions = () => {
        if (this.props.options) {
            return this.props.options.map((option, index) => {
                const disabledStyle: CSSProperties | undefined = option.disabled
                    ? {
                        background: '#efefef'
                    }
                    : undefined

                return (
                    <option
                        key={index}
                        value={option.value}
                        disabled={option.disabled}
                        style={disabledStyle}
                    >
                        {option.label}
                    </option>
                );
            });
        }

        return null;
    }

    render() {
        return (
            <InputGroup className={this.props.inputClass}>
                <InputGroupAddon addonType="prepend">
                    <InputGroupText>{this.props.label}</InputGroupText>
                </InputGroupAddon>
                <Input
                    type={this.props.type}
                    name={this.props.name}
                    id={this.props.id}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    onKeyPress={this.props.onKeyPress}
                    onBlur={this.props.onBlur}
                    disabled={this.props.disabled}
                >
                    { this.getOptions() }
                </Input>
            </InputGroup>
        );
    }
}
